module.exports = __webpack_public_path__ + "img/2023-08.7f714c39.jpg";